<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{
          ['makeI', 'makeII', 'makeIII'].includes(schemeType)
          ? 'Development Agency'
          : 'Vendor Selection'
          }}

        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
     

        <ng-container *ngIf="stepDetails?.can_edit ">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>


      </div>
    </div>
  </div>
  <hr class="my-3" />
  <div class="mb-4 d-flex align-items-start justify-content-between gap-4 mx-4"
  *ngIf="stepDetails?.can_edit">
  <div class="d-flex align-items-start gap-2 w-50">
    <div class="w-75">

      <p-multiSelect [options]="masterVendorList" [(ngModel)]="selectedMasterVendor" optionLabel="name"
        [filter]="true" optionValue="id" filterBy="name" placeholder="Select Vendor(s)" display="chip"
        [showToggleAll]="true" [showClear]="true" [maxSelectedLabels]="3" defaultLabel="Select Vendor(s)">
      </p-multiSelect>
    </div>
    <button [disabled]="!selectedMasterVendor" type="button" class="btn btn-primary w-25 p-2"
      id="vendorMasterDropdown" (click)="addVendorFromMaster()">Add from Master</button>

  </div>
  <button class="btn btn-warning py-2" (click)="openAdd()">Add New Vendor</button>
</div>
    <div *ngIf="schemeType != 'idex'">
      <app-data-table [columns]="cols" [data]="venderList" [title]="title" [isDeletable]="false"
        [isEditable]="false" [showActions]="false" [showAddButton]="false" (editEventRow)="onEdit($event)"
        (onLazyLoadData)="getVendorIdentification($event)" [totalRecords]="totalRecords" ></app-data-table>
    </div>
  
  <!-- <div
    class="mb-4 dropdown-m"
    *ngIf=" stepDetails?.can_edit && schemeType != 'idex'">
    <label for="vendorMasterDropdown" class="form-label">Add from Master</label>
    <p-dropdown
      [options]="masterVendorList"
      [(ngModel)]="selectedMasterVendor"
      optionLabel="name"
      [filter]="true"
      filterBy="name"
      placeholder="Select Vendor"
      (onChange)="addVendorFromMaster()"
      [showClear]="true"
    >
    </p-dropdown>
  </div> -->
  <!-- <div *ngIf="schemeType != 'idex'">
    <app-data-table
      [columns]="cols"
      [data]="venderList"
      [title]="title"
      [isDeletable]="false"
      [isEditable]="false"
      [showActions]="false"
      (onAdd)="openAdd()"
      (editEventRow)="onEdit($event)"
      (onLazyLoadData)="getVendorIdentification($event)"
      [totalRecords]="totalRecords"
      [showAddButton]="stepDetails.can_edit"
    ></app-data-table>
  </div> -->
</div>
<div *ngIf="schemeType == 'idex'">
  <app-data-table [columns]="incubator_cols" [data]="incubatorList" title="List of Vendors" [isDeletable]="false"
    [isEditable]="false" [showActions]="false" (onAdd)="openAdd()" (editEventRow)="onEdit($event)"
    (onLazyLoadData)="getVendorIdentification($event)" [totalRecords]="totalRecords" [showSearch]="false"
    [showAddButton]="stepDetails.can_edit"></app-data-table>
</div>

<ng-container *ngIf="schemeType != 'idex'">
  <p-dialog header="Vendor Details" [(visible)]="visible" [modal]="true" [resizable]="true" [maximizable]="false"
    [style]="{ width: '600px' }" appendTo="body">
    <form [formGroup]="commentForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
        <!-- Vendor Name -->
        <div class="flex flex-col space-y-1">
          <label for="vendor" class="font-semibold text-gray-700">Vendor Name <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="vendor" 
            formControlName="vendor"
            autocomplete="off"
            maxlength="100"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <p *ngIf="commentForm.get('vendor')?.touched && commentForm.get('vendor')?.invalid"
             class="text-red-500 text-xs mt-1">
            Vendor Name is required.
          </p>
        </div>

        <!-- Contact Person -->
        <div class="flex flex-col space-y-1">
          <label for="contactPerson" class="font-semibold text-gray-700">Contact Person's Name <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="contactPerson"
            formControlName="contactPerson"
            autocomplete="off"
            maxlength="100"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <div *ngIf="commentForm.get('contactPerson')?.touched && commentForm.get('contactPerson')?.invalid" class="text-red-500 text-xs mt-1">
            <span *ngIf="commentForm.get('contactPerson')?.hasError('required')">
              Contact Person's Name is required.
            </span>
            <span *ngIf="commentForm.get('contactPerson')?.hasError('pattern')">
              Only alphabets are allowed.
            </span>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Email -->
        <div class="flex flex-col space-y-1">
          <label for="email" class="font-semibold text-gray-700">Email <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="email"
            formControlName="email"
            autocomplete="off"
            type="email"
            maxlength="100"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <div *ngIf="commentForm.get('email')?.touched && commentForm.get('email')?.invalid" class="text-red-500 text-xs mt-1">
            <span *ngIf="commentForm.get('email')?.errors?.['required']">Email is required.</span>
            <span *ngIf="commentForm.get('email')?.errors?.['email']">Invalid email format.</span>
          </div>
        </div>

        <!-- Phone Number -->
        <div class="flex flex-col space-y-1">
          <label for="PhoneNumber" class="font-semibold text-gray-700">Phone Number <span class="text-red-500">*</span></label>
          <div class="flex items-center">
            <span class="inline-flex px-2 py-2 border-2 border-gray-400 border-r-0 bg-gray-100 text-gray-600 rounded-l">+91</span>
            <input 
              pInputText 
              id="PhoneNumber" 
              maxlength="10"
              minlength="10"
              formControlName="phone"
              autocomplete="off"
              placeholder="Enter 10-digit number"
              (keypress)="allowOnlyNumbers($event)"
              class="border-2 border-gray-400 rounded-r px-3 py-2 w-full focus:outline-none focus:border-blue-500"
              style="border-left: none;"
            />
          </div>
          <div *ngIf="commentForm.get('phone')?.touched && commentForm.get('phone')?.invalid" class="text-red-500 text-xs mt-1">
            <span *ngIf="commentForm.get('phone')?.hasError('required')">Phone number is required.</span>
            <span *ngIf="commentForm.get('phone')?.hasError('pattern')">Enter a valid 10-digit phone number.</span>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Address -->
        <div class="flex flex-col space-y-1">
          <label for="address" class="font-semibold text-gray-700">Address <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="address"
            formControlName="address"
            autocomplete="off"
            maxlength="500"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <p *ngIf="commentForm.get('address')?.touched && commentForm.get('address')?.invalid"
             class="text-red-500 text-xs mt-1">
            Address is required.
          </p>
        </div>

        <!-- Tax Registration Number -->
        <div class="flex flex-col space-y-1">
          <label for="taxNumber" class="font-semibold text-gray-700">Tax Registration Number <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="taxNumber"
            formControlName="taxNumber"
            autocomplete="off"
            maxlength="100"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <p *ngIf="commentForm.get('taxNumber')?.touched && commentForm.get('taxNumber')?.invalid"
             class="text-red-500 text-xs mt-1">
            Tax Number is required.
          </p>
        </div>

        <!-- Bank Account Details -->
        <div class="flex flex-col space-y-1 md:col-span-2">
          <label for="bankDetails" class="font-semibold text-gray-700">Bank Account Details <span class="text-red-500">*</span></label>
          <input 
            pInputText 
            id="bankDetails"
            formControlName="bankDetails"
            autocomplete="off"
            maxlength="500"
            class="border-2 border-gray-400 rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
          <p *ngIf="commentForm.get('bankDetails')?.touched && commentForm.get('bankDetails')?.invalid"
             class="text-red-500 text-xs mt-1">
            Bank Details are required.
          </p>
        </div>
      </div>

      <div class="flex justify-end mt-6">
        <button 
          type="submit"
          [disabled]="commentForm.invalid"
          class="bg-blue-600 text-white font-semibold rounded px-6 py-2 transition hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </div>
    </form>
  </p-dialog>
</ng-container>

<ng-container *ngIf="schemeType == 'idex'">
  <p-dialog header="Vendor Details" [(visible)]="visible" [modal]="true" [resizable]="true" [maximizable]="false"
    [style]="{ width: '600px' }" appendTo="body" [closable]="true">
    <form [formGroup]="systemForm" (ngSubmit)="onSubmit()" class="form-wrapper">
      <div class="mt-4 mb-3">
        <label class="form-label"><b>Name</b></label>
        <input type="text" class="form-control" formControlName="name" maxlength="100" />
        <div class="text-danger mt-1" *ngIf="
            systemForm.get('name')?.touched &&
            systemForm.get('name')?.hasError('required')
          ">
          Name is required.
        </div>
      </div>
      <div class="mt-4 mt-3">
        <label for="section"><b>Description</b></label>
        <textarea class="form-control" formControlName="description" rows="4"></textarea>
        <div class="text-danger mt-1" *ngIf="
            systemForm.get('description')?.touched &&
            systemForm.get('description')?.hasError('required')
          ">
          Description is required.
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3 btn-wrapper">
        <!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
        <button type="submit" class="btn btn-primary" [disabled]="systemForm.invalid || systemForm.pristine">
          Submit
        </button>
      </div>
    </form>
  </p-dialog>
</ng-container>

